/**
 * Layout constants for the bottom-right dev debug pill stack on the map.
 */

/** Tailwind class anchoring the stack above MapLibre attribution (~2.75rem). */
export const MAP_DEV_DEBUG_STACK_BOTTOM_CLASS = "bottom-11";

/** Gap between stack children in pixels (flex `gap`). */
export const MAP_DEV_DEBUG_STACK_GAP_PX = 6;

/** z-index shared by the stack and its children (below itinerary panel at z-10). */
export const MAP_DEV_DEBUG_STACK_Z_INDEX = 5;
